var _style, _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageNavIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 180.2 135.5",
    style: {
      enableBackground: "new 0 0 180.2 135.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#384A6E;}\n\t.st1{fill:#6B7A98;}\n\t.st2{fill:#8FA3C5;}\n\t.st3{fill:#A5C3FF;}\n\t.st4{fill:#41516B;}\n\t.st5{fill:#687996;}\n\t.st6{fill:#8D9AB4;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000061470647344794745290000015839139423756177577_"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_copy"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 180.2,
    height: 135.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_11"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "163.1,114 149.2,114.3 140.1,125.2 118.2,114.1 69.6,113.3 68.4,42.5 161.4,43.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M124.5,65.9l-38.8-0.1c0,0-4-0.1-4-3.8s4-3.7,4-3.7s34.3,0,38.5,0s4,4.1,4,4.1 C127.6,66.4,124.5,66,124.5,65.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M145.3,84.7l-59.1-0.1c0,0-4-0.1-4-3.8c0-3.7,4-3.7,4-3.7s54.6,0,58.8,0s4,4.1,4,4.1 C148.3,85.1,145.3,84.8,145.3,84.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M145.1,100.4L86,100.3c0,0-4-0.1-4-3.8c0-3.7,4-3.7,4-3.7s54.6,0,58.8,0s4,4.1,4,4.1 C148.1,100.8,145,100.4,145.1,100.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 144.3,
    cy: 59.3,
    r: 7.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M71,45.5h88v64.2l7.4,8.4c0,0,0.3-65.3,0-72.2c-0.3-6.8-6.3-7.2-6.3-7.2H63.8L71,45.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M71.8,45.5v64.2h48.3l18,10.1l6.6-10.1h14.2l7.3,8.4l-16.9-0.1c0,0-5,7.2-7.4,10.3c-2.4,3-3.3,2-3.3,2 l-20-12.3c0,0-45.3,0-49.7,0s-4.4-4.4-4.4-4.4l-0.5-75L71.8,45.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_11_00000053531756240813326520000002850266628276603789_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "16.2,13.1 126.5,12.3 125.1,96.3 67.4,97.3 41.4,110.4 30.6,97.5 14.1,97.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M55.5,36c0,0-0.3-4.9,4.7-4.9s45.7,0,45.7,0s4.7,0,4.7,4.4s-4.7,4.5-4.7,4.5l-46,0.1 C60,40.2,56.3,40.6,55.5,36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M30.9,54.7c0,0-0.3-4.9,4.7-4.9s69.8,0,69.8,0s4.7,0,4.7,4.4s-4.7,4.5-4.7,4.5l-70.1,0.1 C35.3,58.9,31.7,59.3,30.9,54.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M31.1,73.3c0,0-0.3-4.9,4.7-4.9s69.8,0,69.8,0s4.7,0,4.7,4.4s-4.7,4.5-4.7,4.5l-70.1,0.1 C35.6,77.4,31.9,77.9,31.1,73.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 36.4,
    cy: 32.2,
    r: 9.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M132,7.7H17.8c0,0-7.2,0.5-7.5,8.6c-0.3,8.2,0,85.7,0,85.7l8.8-10V15.8h104.4L132,7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M131.8,7.7l-0.6,89c0,0,0,5.2-5.2,5.2s-59,0-59,0l-23.8,14.6c0,0-1,1.2-3.9-2.4s-8.8-12.2-8.8-12.2 L10.4,102l8.7-10H36l7.8,12l21.4-12h57.3V15.8L131.8,7.7z"
  })))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_copy_2"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000157269885989263135230000016102646445712054457_"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageNavIcon);
export default __webpack_public_path__ + "static/media/messageNavIcon.9a0cccc84050624209d02cd8d3c4f846.svg";
export { ForwardRef as ReactComponent };